<template>
  <div class="mx-auto flex w-full flex-col gap-6">
    <router-view />
  </div>
</template>
